import { Paragraph } from '@customerio/pluma-components/react';
import { createFileRoute } from '@tanstack/react-router';

// Temporary scaffolding for the bare billing shell (SPE-3782). The billing tabs are migrated in
// SPE-3765–3770; once `your-plan` lands (SPE-3765) this index redirects to it as the Ember
// `settings.billing` index does. Until then this placeholder lets the shell chrome (header + tab
// nav) render on `/settings/billing` when the `hydra-billing` flag is on.
function BillingIndexPlaceholder() {
  return <Paragraph variant="secondary">Select a tab to manage your plan and billing.</Paragraph>;
}

export const Route = createFileRoute('/_authenticated/settings/billing/')({
  component: BillingIndexPlaceholder,
});
